import type { SupportedLanguage } from "../i18n";

const InitialState = {
    application: {
        currentLanguage: "en" as SupportedLanguage,
        authorise: false,
        user: null,
        redirectTo: null
    },
    course: {
        data: null,
        selectedSection: null,
        spanishContent: null,
        spanishContentStatus: "idle",
        translationGeneration: 0,
    },
    account: {
        userData: {},
    },
    coupon: {
        data: [],
    }
}
export default InitialState;
